export default __webpack_public_path__ + "static/media/SnehalKadam-CV.48779337.pdf";